// src/app/shared/shared.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { EasyCardComponent } from 'src/app/shared/easy-card/easy-card.component';  // ✅ importa
import { MatIconModule } from '@angular/material/icon';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { MatDialogModule } from '@angular/material/dialog';
import { AbreviarNomePipe } from 'src/app/shared/abreviar-nome.pipe';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { AsArrayPipe } from './pipes/as-array.pipe';
import { KilometersPipe } from './pipes/kilometers.pipe';

@NgModule({
  declarations: [EasyCardComponent, AbreviarNomePipe, EllipsisPipe, KilometersPipe, AsArrayPipe],   // ✅ declara
  imports: [CommonModule, TranslocoModule, MatIconModule, CarouselModule, MatDialogModule],
  exports: [
    CommonModule,
    TranslocoModule,
    MatIconModule,
    EasyCardComponent,
    CarouselModule,
    MatDialogModule,
    AbreviarNomePipe,
    EllipsisPipe,
    AsArrayPipe,
    KilometersPipe,
  ] // ✅ exporta
})
export class SharedModule { }
